<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
        </div>
      </div>
      <vxe-table
        border
        :data="list"
        :column-config="{ resizable: true }"
        :tree-config="{ rowField: 'id', parentField: 'superId' }"
      >
        <vxe-column field="name" title="菜单名称" tree-node min-width="120"></vxe-column>
        <vxe-column field="icon" title="菜单图标"></vxe-column>
        <vxe-column field="type" title="菜单类型"></vxe-column>
        <vxe-column field="order" title="排序"></vxe-column>
        <vxe-column field="path" title="路由地址"></vxe-column>
        <vxe-column field="method" title="请求方法"></vxe-column>
        <vxe-column field="url" title="后端页面路径"></vxe-column>
        <vxe-column title="操作" width="160" >
          <template #default="{ row }">
            <el-link
              v-permission="{ pkey: `${permissionName}_ADD` }"
              href="javascript:void(0);"
              class="mr-10"
              type="primary"
              @click="handleCommand('addRow', row)"
            >
              {{ t("table.add") }}
            </el-link>
            <el-link
              v-permission="{ pkey: `${permissionName}_EDIT` }"
              href="javascript:void(0);"
              class="mr-10"
              type="primary"
              @click="handleCommand('edit', row)"
            >
              {{ t("table.edit") }}
            </el-link>
            <el-link
              v-permission="{ pkey: `${permissionName}_DELETE` }"
              href="javascript:void(0);"
              type="danger"
              @click="handleCommand('delete', row)"
            >
              {{ t("table.delete") }}
            </el-link>
          </template>
        </vxe-column>
      </vxe-table>

      <!-- <TableList
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName.TABLE_MENU"
        :permissionName="permissionName"
        @command-change="handleCommand"
        :canRefresh="false"
        :canChangeColumn="false"
      >
        <template  v-slot:operation-action="scope">
          <el-link
            v-permission="{pkey:`${permissionName}_ADD`}"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('addRow',scope.row)"
          >
            {{ t("table.add") }}
          </el-link>
          <el-link
            v-permission="{pkey:`${permissionName}_EDIT`}"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit',scope.row)"
          >
            {{ t("table.edit") }}
          </el-link>
          <el-link
            v-permission="{pkey:`${permissionName}_DELETE`}"
            href="javascript:void(0);"
            type="danger"
            @click="handleCommand('delete',scope.row)"
          >
            {{ t("table.delete") }}
          </el-link>
        </template>
      </TableList> -->
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="'access'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { deleteMenuById, defaultMenuModel, getMenuDetailByDeptId, getMenuTree } from '@/apis/menu'
import { ArrayRowsItem } from '@/model/Index'
import { useI18n } from 'vue-i18n'
import { getDropdownByType } from '@/apis/tool'
import FormComponent from '@/components/Form/index.vue'
// import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'

export default defineComponent({
  name: 'Menu',
  components: {
    FormComponent
    // TableList
  },

  setup() {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName,
      permissionName: permissionName.MENU,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,

      list: [],
      total: 0,
      listLoading: false,
      superId: 0,
      activeRow: 0,
      activeId: 0,
      deptTop: {
        id: 0,
        name: '顶级菜单'
      },
      superIdOptions: [],
      iconOptions: [],
      dialogFormVisible: false,
      submitLoading: false,
      tempModel: defaultMenuModel,

      getList() {
        dataMap.listLoading = true
        getMenuTree().then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
        // getMenuListByMenuId(dataMap.superId, undefined).then((res: any) => {
        //   dataMap.listLoading = false
        //   dataMap.list = res || []
        // }).catch(() => {
        //   dataMap.listLoading = false
        // })
      },
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate(dataMap.deptTop)
            break
          case 'addRow':
            dataMap.handleCreate(val)
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleSubmit()
            break
        }
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCreate(row: any) {
        dataMap.activeId = 0
        dataMap.loadFormDataSlectOption(row)
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },

      // lazyLoadData(row: any, treeNode: any, resolve: any) {
      //   getMenuListByMenuId(row.id).then((res: any) => {
      //     resolve(res || [])
      //   })
      // },
      handleDelete(row: any) {
        dataMap.activeRow = row
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteMenuById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getMenuDetailByDeptId(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            k.formList.forEach((field: any) => {
              field.value = res[field.fieldKey]
              if (field.fieldKey === 'superId') {
                if (field.value) {
                  getMenuDetailByDeptId(row.superId).then((data: any) => {
                    field.option = [{
                      id: row.superId,
                      name: data.name
                    }]
                  })
                } else {
                  field.option = [dataMap.deptTop]
                  console.log(field.option, 'field.option ')
                }
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      loadFormDataSlectOption(row: any) {
        dataMap.initFormData.forEach((item: any) => {
          item.formList.forEach((k: any) => {
            if (k.fieldKey === 'superId') {
              k.value = row.id
              k.option = [{
                id: row.id,
                name: row.name
              }]
            }
          })
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })
    onMounted(() => {
      dataMap.loadTableSelectOption()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
